import { Tree } from "fluid-framework";
import { useEffect, useState } from "react";

import type { FluidSharedTree } from "../fluid/fluid.client.js";
import { getTableIdFromUser } from "../fluid/fluid.service.js";

export function useCurrentTableId(
  userId: string,
  sharedTree: FluidSharedTree
): string | null {
  const [currentTableId, setCurrentTableId] = useState<string | null>(null);

  useEffect(() => {
    const updateTableId = () => {
      const tableId = getTableIdFromUser({ sharedTree, userId });
      setCurrentTableId((previousTableId) =>
        previousTableId === tableId ? previousTableId : tableId
      );
    };

    updateTableId();

    const unsubscribe = Tree.on(sharedTree.root.tables, "treeChanged", () => {
      updateTableId();
    });

    return () => {
      unsubscribe();
    };
  }, [sharedTree, userId]);

  return currentTableId;
}
